import styled from 'styled-components';

export const StyledSustainability = styled.section`
    position: relative;
    padding-left: ${props => props.offset + 15}px;
    &:after{
        position: absolute;
        height: 50%;
        background: #E0F4FD;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        content: '';
    }

    &:before{
        position: absolute;
        height: 50%;
        background: #EFEFEF;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        content: '';
    }


    .header {
        position: absolute;
        z-index: 15;
        left: ${props => props.offset + 15}px;
        right: 0;
        padding-left: ${props => props.offset + 15}px;
        padding-right: ${props => props.offset + 15}px;
        display: flex;
        top: 100px;
        padding-top: 40px;

        @media(max-width: 767px){
            top: 80px;
            padding-left: ${props => props.offset }px;
            padding-right: ${props => props.offset }px;
            right: 15px;
            &:after{
                width: calc(100% - ${props => (props.offset)}px) !important;

            }
        }
        h6 {
            font-weight: 500;
            font-size: 1rem; /* 16px ÷ 16 */
            line-height: 1.5rem; /* 24px ÷ 16 */
            letter-spacing: 0;
            color: white;
        }

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 1px;
            background: #FFFFFF;
            content: '';
            z-index: 15;
            width: calc(100% - ${props => (props.offset * 2) + 30}px);
            margin: 0 auto;

        }

        .navigation_item {
            display: flex;
            gap: 20px;
        }
    }

    .swiper-button-prev, .swiper-button-next {
        opacity: 0;
        visibility: hidden;
    }

    .sustain {
        padding-left: 0;
        padding-right: 0;

        &__top {
            z-index: 150;
            width: 100%;
            display: flex;
        }

    }


    .swiper-pagination {
        opacity: 0;
        visibility: hidden;
    }

    @media(max-width: 767px){
        padding-left: 0 !important;
    }
`;
